import React, { useContext, useEffect } from "react";

import BinMover from "./mover";
import { useAlert } from "hooks/useAlert";
import { SettingsContext } from "contexts/settings";

const BinMoverIndex = () => {
    const { toggleAlert } = useAlert();
    const { settings } = useContext(SettingsContext);

    useEffect(() => {
        if (settings.globalNotifications.messages.length) {
            toggleAlert({ group: "BinMover" });
        }
    }, [settings.globalNotifications.messages.length]);

    return (
        <div className="container">
            <h1>Bin Mover</h1>
            <BinMover />
        </div>
    );
};

export default BinMoverIndex;
